import { render } from "./pelayananKesehatan.vue?vue&type=template&id=30c7abb4"
import script from "./pelayananKesehatan.vue?vue&type=script&lang=js"
export * from "./pelayananKesehatan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__